import { render, staticRenderFns } from "./rest_summary.vue?vue&type=template&id=236b479c&"
import script from "./rest_summary.vue?vue&type=script&lang=js&"
export * from "./rest_summary.vue?vue&type=script&lang=js&"
import style0 from "./rest_summary.vue?vue&type=style&index=0&id=236b479c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports